import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BookNowButton from "./components/BookNowButton";
import Index from "./pages/Index";
import Store from "./pages/Store";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Newsletter from "./pages/Newsletter";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import FacialAesthetics from "./pages/services/FacialAesthetics";
import HairRestoration from "./pages/services/HairRestoration";
import IVTherapy from "./pages/services/IVTherapy";
import BodyTreatments from "./pages/services/BodyTreatments";
import Neurotoxins from "./pages/services/Neurotoxins";
import Fillers from "./pages/services/Fillers";
import Peels from "./pages/services/Peels";
import Facials from "./pages/services/Facials";
import Cryolipolysis from "./pages/services/Cryolipolysis";
import FUEHairRestoration from "./pages/services/FUEHairRestoration";
import PRP from "./pages/services/PRP";
import Exosomes from "./pages/services/Exosomes";
import RedLightLaser from "./pages/services/RedLightLaser";
import HairSupplements from "./pages/services/HairSupplements";
import Mesotherapy from "./pages/services/Mesotherapy";
import IPL from "./pages/services/IPL";
import GLP1Therapy from "./pages/services/GLP1Therapy";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <BookNowButton />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/store" element={<Store />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/services/facial-aesthetics" element={<FacialAesthetics />} />
          <Route path="/services/hair-restoration" element={<HairRestoration />} />
          <Route path="/services/iv-therapy" element={<IVTherapy />} />
          <Route path="/services/body-treatments" element={<BodyTreatments />} />
          <Route path="/services/neurotoxins" element={<Neurotoxins />} />
          <Route path="/services/fillers" element={<Fillers />} />
          <Route path="/services/peels" element={<Peels />} />
          <Route path="/services/facials" element={<Facials />} />
          <Route path="/services/cryolipolysis" element={<Cryolipolysis />} />
          <Route path="/services/fue-hair-restoration" element={<FUEHairRestoration />} />
          <Route path="/services/prp" element={<PRP />} />
          <Route path="/services/exosomes" element={<Exosomes />} />
          <Route path="/services/red-light-laser" element={<RedLightLaser />} />
          <Route path="/services/hair-supplements" element={<HairSupplements />} />
          <Route path="/services/mesotherapy" element={<Mesotherapy />} />
          <Route path="/services/ipl" element={<IPL />} />
          <Route path="/services/glp1-therapy" element={<GLP1Therapy />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;